<template>
    <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 :disabled="title == '查看文件数据源'"
                 label-width="110px">
            <el-form-item label="上传文件：" prop="fileUrl">
                <resume-upload ref="resumeUpload" :uploadNum="1" :upFileSize="50" :allowFiles="['txt','zip']" :filtButton="true"
                               @upFileDate="getFileData"></resume-upload>
                <div class="upFile flex_b_c" v-show="this.searchForm.fileUrl">
                    <div class="flex_l_c">
                        <i class="el-icon-tickets"></i>
                        <div>{{ searchForm.fileName }}</div>
                    </div>
                    <i class="el-icon-error" @click="deleteUpFile()"></i>
                </div>
            </el-form-item>
            <el-form-item label="数据源描述：" prop="fileDescription">
                <el-input
                        type="textarea"
                        placeholder="数据源描述(限200字)"
                        v-model="searchForm.fileDescription"
                        maxlength="200"
                        rows="5" resize="none"
                ></el-input>
            </el-form-item>
            <el-form-item label="执行周期：" prop="fileCron">
                <div class="flex_b_c">
                    <el-input v-model.trim="searchForm.fileCron" maxlength="50"
                              placeholder="请输入执行周期(限50字)" style="margin-right: 10px"
                              clearable></el-input>
                    <el-popover
                            placement="top-start"
                            width="600"
                            trigger="hover">
                        <div style="white-space: pre-wrap;">
                            Cron表达式是一个由6个子表达式组成的字符串。每个子表达式都描述了一个单独的日程细节。
                            这些子表达式用空格分隔，分别表示：<br>
                            秒（0~59）<br>
                            分钟（0~59）<br>
                            小时（0~23）<br>
                            天（月）（1~31，取决于月份）<br>
                            月（1~12）<br>
                            天（星期）（可使用数字或英文缩写，如1或者MON,其中0和7都代表星期天（SUN））<br>
                            其中每个元素可以是一个值（如6）,一个连续区间（9-12）,一个间隔时间（8-18/4）
                            （表示8-18中每隔4（分钟、小时......取决于子表达式））,一个列表（1,3,5）,通配符。<br>
                            由于"月份中的日期"和"星期中的日期"这两个子表达式是互斥的,必须要对其中一个设置"?".<br>
                            cron表达式举例：<br>
                            0 0 10,14,16 * * ? 每天上午10点，下午2点，4点<br>
                            0 0/30 9-17 * * ? 朝九晚五工作时间内每半小时<br>
                            0 0 12 ? * WED 表示每个星期三中午12点<br>
                            0 0 12 * * ? 每天中午12点触发<br>
                            0 15 10 ? * * 每天上午10:15触发<br>
                            0 15 10 * * ? 每天上午10:15触发<br>
                            0 * 14 * * ? 在每天下午2点到下午2:59期间的每1分钟触发<br>
                            0 0/5 14 * * ? 在每天下午2点到下午2:55期间的每5分钟触发<br>
                        </div>
                        <div slot="reference" class="iconPrompt el-icon-question"></div>
                    </el-popover>
                </div>
            </el-form-item>
            <!--            <el-form-item label="同步数据值：" prop="synchronizationType">-->
            <!--                <el-select style="width: 100%" v-model="searchForm.synchronizationType"-->
            <!--                           clearable-->
            <!--                           placeholder="同步数据值">-->
            <!--                    <el-option-->
            <!--                            v-for="item in synchronizationTypeList"-->
            <!--                            :key="item.value"-->
            <!--                            :label="item.label"-->
            <!--                            :value="item.value">-->
            <!--                    </el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="同名覆盖：" prop="fileCover">
                <el-checkbox v-model="searchForm.fileCover" true-label="1" false-label="0">同名覆盖</el-checkbox>
            </el-form-item>
        </el-form>
        <div v-if="title != '查看文件数据源'" slot="footer" class="text_right">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
        <div v-else slot="footer" class="text_right">
            <el-button size="small" @click="visible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {isValidCron} from "cron-validator";
import ResumeUpload from "@/components/Upload/resumeUpload.vue";

export default {
    name: "fileAdd",
    components: {ResumeUpload},
    data() {
        var verifyExpression = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入cron表达式'));
            } else {
                if (!isValidCron(value)) {
                    callback(new Error('请输入正确的cron表达式'));
                } else {
                    callback();
                }
            }
        };
        return {
            title: '新建文件数据源',
            visible: false,
            searchForm: {
                id: '',
                fileUrl: '',
                fileName: '',
                fileDescription: '',
                fileCron: '',
                // synchronizationType: '',
                fileCover: '0',
            },
            rules: {
                fileUrl: [
                    {required: true, message: '请上传文件', trigger: 'blur'}
                ],
                fileCron: [
                    {validator: verifyExpression, trigger: 'blur'},
                    {required: true, message: '请输入cron表达式', trigger: 'blur'}
                ],
                // synchronizationType: [
                //     {required: true, message: '请选择同步数据值', trigger: 'change'}
                // ],
            },
            uploadAskObj: {
                count: 1,
                megaNum: 50,
                showFile: true,
                fileType: ['txt']
            },
            synchronizationTypeList: [
                {
                    label: '全部同步',
                    value: '0',
                },
                {
                    label: '增量同步',
                    value: '1',
                },
            ],
        }
    },

    methods: {
        //typeName see查看 edit编辑 add新增
        init(typeName, row) {
            this.visible = true
            this.deleteUpFile()
            this.searchForm.id = ''
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (typeName == 'add') {
                this.title = '新建文件数据源'
            }
            if (typeName == 'edit') {
                this.title = '编辑文件数据源'
                this.getDetail(row)
            }
            if (typeName == 'see') {
                this.title = '查看文件数据源'
                this.getDetail(row)
            }
        },

        //获取详情
        getDetail(row) {
            this.$axios(this.api.academic.filesourceGetById + row.id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                    if (this.searchForm.fileUrl){
                        this.$refs.resumeUpload.setOldFile([
                            {
                                fileName:this.searchForm.fileName,
                                fileUrl:this.searchForm.fileUrl,
                            },
                        ])
                    }
                }
            })
        },

        //获取上传的文件
        getFileData(data) {
            this.searchForm.fileUrl = data[0].upDate.netUrl
            this.searchForm.fileName = data[0].upDate.fileName
        },

        //删除上传文件
        deleteUpFile(){
            this.searchForm.fileUrl = ''
            this.searchForm.fileName = ''
            this.$nextTick(()=>{
                this.$refs.resumeUpload.clearAllFile()
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.filesourceUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.filesourceSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.iconPrompt {
    font-size: 22px;
    width: 22px;
    height: 22px;
}

.upFile{
    border: 1px solid #C0C0C0;
    padding: 5px 10px;
    border-radius: 4px;
    .el-icon-tickets{
        margin-right: 15px;
        font-size: 24px;
    }
    .el-icon-error{
        font-size: 16px;
        cursor: pointer;
    }
}
</style>